import MonitorModule from "./MonitorModule";
var monitor_module_default = MonitorModule;
export {
  MonitorModule,
  monitor_module_default as default
};

//# sourceMappingURL=index.js.map